import React from 'react';
import { LevelProgressBarProps } from '@msc-b2c/interfaces/types';
import { Image, Text } from '@msc-b2c/shared-components';
import styles from './levelProgressBar.module.scss';
import { getUserLevelTotalProgress } from '../../../utils/myAreaVoyagerClubUtils';

export function LevelProgressBar({ levels, currentPoints }: Readonly<LevelProgressBarProps>) {
  // Ascending by required points; CSS handles mobile reversal
  const levelsAsc = [...levels].sort((a, b) => (a.pointsRequired || 0) - (b.pointsRequired || 0));

  const progressStyle = {
    '--progress': `${getUserLevelTotalProgress(levelsAsc, currentPoints)}%`,
  } as React.CSSProperties;

  return (
    <div className={styles['cmp-level-progress-bar']}>
      <div className={styles['cmp-level-progress-bar__container']}>
        <div
          className={styles['cmp-level-progress-bar__fill']}
          style={progressStyle}
        />
      </div>

      <div className={styles['cmp-level-progress-bar__levels']}>
        {levelsAsc.map((level, index) => (
          <div
            key={index}
            className={styles['cmp-level-progress-bar__level']}
          >
            <div className={styles['cmp-level-progress-bar__level-name']}>
              <Text
                text={level.levelName}
                styleOption={`bold`}
              />
            </div>
            {level.levelImageUrl && (
              <Image
                src={level.levelImageUrl}
                alt={level.levelImageAlt ?? level.levelName}
                styleOption={styles['cmp-level-progress-bar__level-image']}
              />
            )}
            <div className={styles['cmp-level-progress-bar__level-points']}>
              <Text
                text={level.levelContent?.toLocaleString() || ''}
                styleOption={styles['']}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default LevelProgressBar;
